<template>
  <div id="publishing-guest-editor-add">
    <ipub-model :title="params.id?'Edit Guest Editor':'Add New Guest Editor'"
                width="1100px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="guest-editor-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-row>
          <ipub-col :span="9.5">
            <ipub-row :gutter="20">
              <ipub-col :span="4">
                <ipub-form-item prop="titleCode"
                                label="Title">
                  <ipub-select v-model="params.titleCode"
                               placeholder="Select title">
                    <ipub-select-option v-for="(value) in titleList"
                                        v-show="value.enabled"
                                        :key="value.id"
                                        :value="value.code">
                      {{ value.name }}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="firstName"
                                label="First Name">
                  <ipub-input placeholder="Enter first name"
                              v-model.trim="params.firstName" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="lastName"
                                label="Last Name">
                  <ipub-input placeholder="Enter last name"
                              v-model.trim="params.lastName" />
                </ipub-form-item>
              </ipub-col>

            </ipub-row>
            <ipub-row :gutter="20">
              <ipub-col :span="4">
                <ipub-form-item prop="sort"
                                label="Hierarchy">
                  <ipub-input placeholder="Enter hierarchy"
                              number
                              v-model="params.sort" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="email"
                                label="Email">
                  <ipub-input placeholder="Enter frequency used public email"
                              @blur="getGuestEditor"
                              v-model.trim="params.email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="identityCode"
                                label="Identity">
                  <ipub-select v-model="params.identityCode"
                               placeholder="Select identity">
                    <ipub-select-option v-for="(value) in guestEditorList"
                                        v-show="value.enabled"
                                        :key="value.id"
                                        :value="value.code">
                      {{value.name}}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>

            </ipub-row>

          </ipub-col>
          <ipub-col :span="2.5"
                    class="relative">
            <ipub-form-item prop="icon">
              <div class="upload-content right-option">
                <div class="upload-content-img">
                  <ipub-upload-cropper @change="(e)=>{handleUpload('icon', e)}"
                                       :canWidth="105"
                                       :canHeight="130"
                                       :scales="2"
                                       :imgUrl="params.icon?domain+'/'+params.icon:domain+'/imageFile/icon.svg'" />
                </div>
              </div>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>

        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="rankId"
                            label="Academic Rank / Scientific Rank">
              <ipub-select v-model="params.rankId"
                           search
                           @search="getAcademic"
                           placeholder="Select academic rank / scientific rank"
                           :options="academicList">
                <ipub-select-option v-for="item in academicList"
                                    v-show="item.enabled"
                                    :key="item.id"
                                    :value="item.id"> {{item.name}}<template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="degreesIdList"
                            label="Degree / Credential">
              <ipub-select placeholder="Select degree / credential"
                           mode="multiple"
                           :tree="true"
                           search
                           @search="getDegrees"
                           v-model="params.degreesIdList">
                <ipub-select-option v-for="item in degreesList"
                                    v-show="item.enabled"
                                    :key="item.id"
                                    :value="item.id"> {{item.name}}<template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="countryCode"
                            label="Country / Territory">
              <ipub-select v-model="params.countryCode"
                           search
                           :clear="true"
                           @search="countrySearch"
                           placeholder="Country / Territory">
                <ipub-select-option v-for="item in countryList"
                                    :value="item.code"
                                    :key="'countryList'+item.code">
                  {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="City"
                            label="City">
              <ipub-input placeholder="City"
                          v-model.trim="params.city" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="affiliation"
                        label="Affiliations">
          <div slot="label"
               class="ipub-p2 fw-bd mar-b-10">Affiliations<font class="key-color">*</font><a class="link-color mar-l-20"
               @click="addMore('affiliations')">
              <font>
                <ipub-icon type="iconAdd" />
                Add New Affiliation
              </font>
            </a></div>
          <div v-for="(item, index) in params.affiliations"
               class="mar-b-10"
               :key="'params.affiliations'+index">
            <ipub-input placeholder="Enter affiliation details"
                        :suffixIcon="index===0?'':'iconClose'"
                        @blur="getMore('affiliation')"
                        @iconClick="delMore('affiliations',index)"
                        v-model.trim="params.affiliations[index]" />
          </div>
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="2">
            <ipub-form-item prop="hindex"
                            label="H-index">
              <!-- <div slot="label"
                   style="margin-bottom:9px">
                H-index <font class="key-color">*</font>
              </div> -->
              <ipub-input placeholder="Enter H-index"
                          :disabled="!params.hindexed"
                          number
                          class="mar-b-8"
                          v-model="params.hindex" />
              <ipub-radio :checked="params.hindexed"
                          class="ipub-p2"
                          @change="()=>{params.hindexed = !params.hindexed}"
                          label="Show H-index" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="10">
            <ipub-form-item prop="hindexUrl"
                            label="H-index URL">
              <ipub-input placeholder="Enter H-index URL"
                          v-model.trim="params.hindexUrl" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>

        <ipub-form-item prop="interest"
                        label="Interests">
          <!-- <ipub-editor :height="200"
                       v-model="params.interest" /> -->
          <ipub-textarea :autoSize="{ cols: '', rows: '5' }"
                         v-model="params.interest" />
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="4">
            <ipub-form-item prop="orcid"
                            label="">
              <div slot="label"
                   class="ipub-p2 fw-bd mar-b-10">
                <ipub-icon class="ipub-p4"
                           style="font-size:14px;color:#a6ce39"
                           type="iconORCID" /> ORCID
                <ipub-tooltip placement="right"
                              type="dark">
                  <div slot="title">
                    Like 0000-0001-2345-6789 or 0000123455556789
                  </div>
                  <ipub-icon class="ipub-p1"
                             style="font-size:14px;"
                             type="iconInfo" />
                </ipub-tooltip>
              </div>
              <ipub-input placeholder="Encourage to input"
                          v-model.trim="params.orcid" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="researchGate"
                            label="ReasearchGate Account">
              <ipub-input placeholder="Enter ResearchGate account"
                          v-model.trim="params.researchGate" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="website"
                            label="Personal Homepage">
              <ipub-input placeholder="Enter personal homepage URL"
                          v-model.trim="params.website" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="reviewJournal"
                        label="Reviewed Journal">
          <div slot="label"
               class="ipub-p2 fw-bd mar-b-10">Reviewed Journal<font class="key-color">*</font><a class="link-color mar-l-20"
               @click="addMore('reviewJournals')">
              <font>
                <ipub-icon type="iconAdd" />
                Add New Reviewed Journal
              </font>
            </a></div>
          <div v-for="(item, index) in params.reviewJournals"
               class="mar-b-10"
               :key="'params.reviewJournals'+index">
            <ipub-input placeholder="Enter reviewed journal’s full name"
                        suffixIcon="iconClose"
                        @blur="getMore('reviewJournal')"
                        @iconClick="delMore('reviewJournals',index)"
                        v-model.trim="params.reviewJournals[index]" />
          </div>
          <!-- <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('reviewJournals')"
                       style="width:240px"
                       plain>Add Reviewed Journal</ipub-button> -->
        </ipub-form-item>
        <ipub-form-item prop="cv">
          <div class="mar-b-10 ipub-p1 relative"
               slot="label">
            CV
            <ipub-tooltip placement="right"
                          type="dark"
                          class="mar-l-10">
              <div slot="title">PDF</div>
              <ipub-icon type="iconInfo" />
            </ipub-tooltip>
          </div>
          <ipub-upload-input :file="params"
                             _name="cvName"
                             _path="cv"
                             class="mar-b-20"
                             :domain="domain"
                             @delete="delFile('cv')"
                             @change="(e)=>{handleUpload('cv', e)}" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import { eboard } from '@/api/eboard'
import help from '@/utils/help'
import section from '@/api/section'
import special from '@/api/special'
import check from '@/utils/check'
import { settingCountry, settingOption } from '@/api/setting'
export default {
  components: {
  },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
    editors: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      params: {
        hindexed: false,
        affiliations: [''],
        reviewJournals: [''],
        icon: '',
        interest: '',
        iconName: '',
        cv: '',
        cvName: '',
        email: '',
      },
      rules: {},
      sections: [],
      degreesList: [],
      academicList: [],
      titleList: [],
      guestEditorList: [],
      isCropper: false,
      canWidth: 200,
      canHeight: 225,
      countryList: []

    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
      guestEditor: 'getGuestEditor',
      degree: 'getDegree'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          hindexed: false,
          affiliations: [''],
          reviewJournals: [''],
          icon: '',
          iconName: '',
          cv: '',
          interest: '',
          cvName: '',
          email: ''
        }
      } else {
        const { journalId, ...data } = JSON.parse(JSON.stringify(this.inputData))
        this.getSection(journalId)
        const { affiliation, reviewJournal, degreesList } = data
        data.affiliations = affiliation ? affiliation.split(';') : ['']
        data.reviewJournals = reviewJournal ? reviewJournal.split(';') : []
        data.degreesIdList = degreesList
          ? degreesList.map(item => {
            return item.id
          })
          : []
        data.icon = data.icon || ''
        data.interest = data.interest || ''
        this.params = Object.assign(this.params, data)
        this.getData()
      }
    }
  },
  mounted () {
    this.getRules()

  },
  methods: {
    async getQuery (id, data) {
      const res = await eboard.query(id, data)
      const { affiliation, reviewJournal, degreesList } = res || {}
      res.affiliations = affiliation ? affiliation.split(';') : ['']
      res.reviewJournals = reviewJournal ? reviewJournal.split(';') : []
      res.degreesIdList = degreesList
        ? degreesList.map(item => {
          return item.id
        })
        : []
      res.rankId = res.rank.id
      res.icon = res.icon || ''
      this.params = res
    },
    async getSection (journalId) {
      this.sections = await section.getAll({ journalId })
    },
    async getData () {
      const academicList = await settingOption.get({ type: 'ACADEMIC_RANK' })
      const degreesList = await settingOption.get({ type: 'DEGREE' })
      const titleList = await settingOption.get({ type: 'TITLE' })
      const guestEditorList = await settingOption.get({ type: 'GUEST_EDITOR_IDENTITY' })
      this.academicList = academicList
      this.degreesList = degreesList
      this.titleList = titleList
      this.guestEditorList = guestEditorList
      this.countrySearch()
    },

    async getAcademic (keyword) {
      this.academicList = await settingOption.get({ keyword, type: 'ACADEMIC_RANK' })

    },
    async getDegrees (keyword) {
      this.degreesList = await settingOption.get({ keyword, type: 'DEGREE' })
    },

    async countrySearch (val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },

    addMore (key) {
      this.params[key].push('')
    },
    delMore (key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    getMore (key) {
      const arr = []
      this.params[key + 's'].forEach(item => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },
    async handleUpload (key, files) {
      const file = files[0]
      const imgFiles = ['icon']
      const pdfFiles = ['cv']
      const imgTypes = ['image/jpeg', 'image/png']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (imgFiles.includes(key)) {
        rightType = imgTypes.includes(file.type)
      } else if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/journal/${this.inputData.journalId}/guest-editor/${key}/${help.guid()}`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
    },

    cancelCopper () {
      this.isCropper = false
    },
    uploadCropper () {
      this.isCropper = true
    },

    delFile (key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    goToPage (val, name) {
      help.download(val, name)
    },

    async confirm () {
      const flag = this.$refs['guest-editor-add-form'].validate()
      // if (
      //   !this.params.degreesIdList ||
      //   (this.params.degreesIdList && this.params.degreesIdList.length === 0)
      // ) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Degree / Credential cannot be empty!'
      //   })
      //   return
      // }
      if (flag) {
        this.getMore('affiliation')
        this.getMore('reviewJournal')
        this.$message.success({ title: 'Success', content: 'This Guest Editor has been saved!' })
        this.$emit('confirm', this.params)
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    async getGuestEditor () {
      if (check.email(this.params.email)) {
        const res = await special.geditorSearch(this.params.email)
        if (!res) {
          return
        }
        const { affiliation, reviewJournal } = res || {}
        res.affiliations = affiliation ? affiliation.split(';') : ['']
        res.reviewJournals = reviewJournal ? reviewJournal.split(';') : []
        res.rankId = res.rank && res.rank.id
        res.degreesIdList = res.degreesList ? res.degreesList.map(item => {
          return item.id
        }) : []
        res.icon = res.icon || ''
        this.params = Object.assign(this.params, res)
      }
    },
    getRules () {
      this.rules = {
        // titleCode: [
        //   {
        //     required: true,
        //     message:
        //       'Title' +
        //       this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        firstName: [
          {
            required: true,
            message:
              'First Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message:
              'Last Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        email: [
          {
            required: true,
            message:
              'Email' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email'
          },
        ],
        orcid: [
          {
            fun: check.orcid,
            message: `Encourage input ORCID`
          }
        ],
        identityCode: [
          {
            required: true,
            message:
              'Identity' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        affiliation: [
          {
            required: true,
            message:
              'Affiliations' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        website: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'Website'
          }
        ],
        hindexUrl: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'H-index Url'
          }
        ],
        countryCode: [
          {
            required: true,
            message:
              'Country / Territory' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        city: [
          {
            max: 256,
            message: `City length must not be more than 256 digits`
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#publishing-guest-editor-add {
  .upload-content {
    height: 140px;
    width: 135px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-img {
      border-radius: 4px;
      height: 140px;
      width: 125px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
